
export { useWalletCollectiblesLists } from "/home/runner/work/capsicum/capsicum/libs/features/wallet/shared/src/hooks/useWalletCollectiblesLists.ts"